module.exports = __webpack_public_path__ + "images/kihnu/apple-touch-icon.png";